module.exports = __webpack_public_path__ + "static/media/custom-colr.c15c23af.png";